<script setup>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    pageName: 'centerShops'
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Auth
const authStore = useAuthStore()
const { isLoggedIn } = storeToRefs(authStore)

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.SHOPS_OVERVIEW,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    loginStatus: isLoggedIn.value ? TRACKING_CONSTANTS.MISC.LOGGED_IN : TRACKING_CONSTANTS.MISC.LOGGED_OUT
})

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.header_navigation_hub_web} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <CenterHeader />

        <ContentMainHeadline :content-main-headline-config="{ title: staticKeys?.shops_overview_headline }" />

        <ShopListOverview />
    </PageMainContainer>
</template>
